import { createAction } from 'redux-act';
export var setActivePerformanceTab = createAction('SIGNAL_ROUTER/SET_ACTIVE_PERFORMANCE_TAB');